<template>
  <div>
  <div class="register-wrapper row d-flex mr-0 ml-0 p-0">
    <div class="col-xs-4 show-md mobile-menu-btn pr-0">
      <div class=" d-flex menu-btn align-items-end flex-direction-column row-gap-5 pr-10"
        aria-expanded="false"
        data-toggle="collapse"
        data-target="#NavBar_DropDown_Register" @click="showImage"
        id="burger">
        <div>
          <img v-show="show_burger_icon" alt="inmetro-logo" src="/static/images/logos/Union.svg" class="burger_icon" />
           <img v-show="!show_burger_icon" alt="inmetro-logo" src="/static/images/logos/Close X.svg" class="close_icon" />
        </div>
      </div>
    </div>
    <!-- <ul id="NavBar_DropDown_Register" aria-expanded="false" class="collapse p-20">
      <img class="medium_device_logo" alt="inmetro-logo" src="/static/images/logos/inmetro_medium_device_logo.svg" />
      <li class="padding-0">
        <div class="break-line"></div>
      </li>
      <li>
        <div class="userProfileDropDown">
          <div class="language_dropdown">
            <div class="languagePlaceholder">{{$t('language')}}</div>
            <div class="carretSection">
              <span>
                    <button data-toggle="collapse" data-target="#collapseLanguageDropdown" data-parent="#accordion">
                      <img src="/static/images/icons/chevron_up_purple.svg" class="downCarret" />
                      <img src="/static/images/icons/chevron_up_purple.svg" class="upCarret" />
                    </button>
                  </span>
            </div>
          </div>
               <div class="collapse languagesList" id="collapseLanguageDropdown">
                 <ul>
                   <li class="languageItem">
                     <button data-toggle="collapse" data-target="#collapseLanguageDropdown" data-parent="#accordion">
                       <div class="settings-title">
                         <div class="li-title" @click="changeLanguage('English')">{{$t('english')}}</div>
                       </div>
                     </button>
                   </li>
                   <li class="languageItem portugueseItem">
                     <button data-toggle="collapse" data-target="#collapseLanguageDropdown" data-parent="#accordion">
                       <div class="settings-title">
                         <div class="li-title" @click="changeLanguage('Portuguese')">{{$t('portuguese')}}</div>
                       </div>
                     </button>
                   </li>
                 </ul>
               </div>
           </div>
      </li>
      <li>
        <div class="horizontal-line"></div>
      </li>
      <li>
        <router-link
          data-toggle="collapse"
          data-target="#NavBar_DropDown_Register"
          to="/register"
        >{{$t('createAccount')}}</router-link>
      </li>
      <li>
        <div class="horizontal-line"></div>
      </li>
      <li>
        <router-link data-toggle="collapse" data-target="#NavBar_DropDown_Register" to="/login">{{$t('login')}}</router-link>
      </li>
      <li>
        <div class="horizontal-line"></div>
      </li>
      <li @click="openSaasModal('sass')">
        <a>{{$t('inmetroSaaSAgreement')}}</a>
      </li>
      <li>
        <div class="horizontal-line"></div>
      </li>
      <li @click="openSaasModal('termsOfUse')">
        <a>{{$t('inmetroTermsOfUse')}}</a>
      </li>
      <li>
        <div class="horizontal-line"></div>
      </li>
      <li @click="openSaasModal('privacyPolicy')">
        <a>{{$t('privacyPolicy')}}</a>
      </li>
    </ul> -->
    <!-- <div class="col-xs-12 col-sm-5 p-0 h-100 img-wrapper">
      <div class="col-xs-12 image-content">
        <div class="col-xs-12 pb-75 pl-0">
            <img
            class="inmetro-image"
            alt="inmetro-img"
            src="/static/images/logos/inmetro_signup_logo.png"
          />
        </div>
        <div class="inmetro-acct col-xs-12 p-0 fw-300">{{$t('createAccountSmallCase')}}<br>{{$t('createAccountSmallCaseNextLine')}}</div>
        <div class="inmetro-para col-xs-12 p-0">
          {{$t('inmetroPara')}}
        </div>
      </div>
    </div> -->
    <div class="col-xs-12 col-sm-12 h-100 pl-0 pr-0 form-details">
      <!-- <div class="mainHeaderNav">
        <div class="col-xs-9 d-flex justify-content-end col-gap-30 md-hide action-buttons font-18">
          <router-link to="/login">{{$t('login')}}</router-link>
        </div>
        <div class="col-xs-3 d-flex justify-content-end align-items-center">
          <div class="lang-dropdown">
            <multiselect
            :showLabels="false"
            class="multiselect-single-dropdown"
            :placeholder="selectedLanguageLabel"
            :options="languages"
            :searchable="false"
            @select="changeLanguage"
            >
          </multiselect>
            </div>
          </div>
      </div> -->
      <login-header @openModal="openModal"></login-header>
          <div class="col-sm-12 p-0 checkbox-error-section" v-if="termsErr">
            <div><img class="check-box-error-info" src="/static/images/icons/check-box-error-info.png" /></div>
            <div class="checkbox-error" >{{ termsErr }}</div>
            <div><img class="chechBox-error-cancel-icon" src="/static/images/icons/chechBox-error-cancel-icon.png" @click="closeTermsErr" /></div>
          </div>
      <div class="registration-wrapper">
      <div class="col-xs-12 create-account p-0 crt-acct mb-20 fw-300">
        {{$t('createAccount')}}
      </div>
      <div class="col-xs-12 account-info p-0">
        <!-- {{$t('createAccountSubHeading')}} -->
      </div>
      <form @submit.prevent="submit">
        <div>
          <div class="col-md-12 col-lg-12 max-height">
            <div class="create-account">
              <div class="">
                <h4 class="comp-info mt-0">{{$t('userInfo')}}</h4>
                <div class="row content">
                  <div class="col-md-6 p-0 pr-12">
                    <p class="align-left mb-0 ft-14 field_head asterisk">{{$t('firstName')}}</p>
                    <div class="form-group" :class="$v.user_data.first_name.$error ? 'mb-12':''">
                      <input
                        class="form-control comn_border"
                        :class="$v.user_data.first_name.$error ? 'invalid-border':''"
                        v-model.trim="user_data.first_name"
                        type="text"
                        :placeholder="$t('firstNamePlaceholder')"
                        maxlength="35"
                        @blur="$v.user_data.first_name.$touch()"
                      />
                      <div v-if="$v.user_data.first_name.$error">
                        <div
                          class="custom-error-class"
                          v-if="!$v.user_data.first_name.required"
                        >
                          {{$t('completeRequiredField')}}
                        </div>
                        <div
                          class="custom-error-class"
                          v-else-if="!$v.user_data.first_name.minLength"
                        >{{$t('min2CharactersRequired')}}.</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 p-0 pl-12">
                    <p class="align-left mb-0 ft-14 field_head asterisk">{{$t('lastName')}}</p>
                    <div class="form-group" :class="$v.user_data.last_name.$error ? 'mb-12':''">
                      <input
                        class="form-control comn_border"
                        :class="$v.user_data.last_name.$error ? 'invalid-border':''"
                        type="text"
                        :placeholder="$t('lastNamePlaceholder')"
                        v-model.trim="user_data.last_name"
                        maxlength="30"
                        @blur="$v.user_data.last_name.$touch()"
                      />
                      <div v-if="$v.user_data.last_name.$error">
                        <div
                          class="custom-error-class"
                          v-if="!$v.user_data.last_name.required"
                        >
                          {{$t('completeRequiredField')}}</div>
                        <div
                          class="custom-error-class"
                          v-else-if="!$v.user_data.last_name.minLength"
                        >{{$t('min2CharactersRequired')}}.</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row content">
                  <div class="col-md-6 p-0 pr-12">
                    <p class="align-left mb-0 ft-14 field_head asterisk">Email</p>
                    <div class="form-group form-email" :class="$v.user_data.email.$error ? 'mb-12':''">
                      <input
                        class="form-control comn_border"
                        :class="{'invalid-border': $v.user_data.email.$error || isFreeDomain }"
                        type="text"
                        :placeholder="$t('emailPlaceholder')"
                        v-model.trim="user_data.email"
                        maxlength="65"
                        @blur="checkEmailIsValid()"
                      />
                      <div v-if="$v.user_data.email.$error">
                        <div
                          class="custom-error-class"
                          v-if="!$v.user_data.email.required"
                        >
                          {{$t('completeRequiredField')}}</div>
                        <div
                          class="custom-error-class"
                          v-else-if="!$v.user_data.email.isValidMail"
                        >
                          {{$t('invalidEmailEntry')}}</div>
                      </div>
                      <div class="custom-error-class" v-else-if="isFreeDomain">
                          {{$t('freeDomainErrorMsg')}}
                        </div>
                    </div>
                  </div>
                  <div class="col-md-6 p-0 pl-12">
                    <p class="align-left mb-0 ft-14 field_head asterisk">{{$t('phoneNumber')}}</p>
                    <div class="form-group" :class="$v.user_data.mobile.$error ? 'mb-12':''">
                      <input
                        class="form-control comn_border"
                        :class="$v.user_data.mobile.$error ? 'invalid-border':''"
                        type="text"
                        size="15"
                        maxlength="20"
                        :placeholder="$t('phoneNumberPlaceholder')"
                        v-model="user_data.mobile"
                        @blur="$v.user_data.mobile.$touch()"
                      />
                      <div v-if="$v.user_data.mobile.$error">
                        <div
                          class="custom-error-class"
                          v-if="!$v.user_data.mobile.required"
                        >
                          {{$t('completeRequiredField')}}</div>
                        <div
                          class="custom-error-class"
                          v-if="!$v.user_data.mobile.isNumber && $v.user_data.mobile.$error"
                        >
                          {{$t('enterOnlyNumbers')}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="password-conf">
                  <div class="row content">
                    <div class="col-md-6 p-0 pr-12">
                      <p class="align-left mb-0 ft-14 field_head asterisk">{{$t('password')}}</p>
                      <div class="form-group" :class="!passwordError && submitStatus ? 'mb-12':''">
                        <input
                          id="password"
                          class="form-control comn_border password-color"
                          :class="!passwordError && submitStatus ? 'invalid-border':''"
                          type="password"
                          maxlength="65"
                          :placeholder="$t('passwordPlaceholder')"
                          v-model="user_data.password"
                          autocomplete="new-password"
                          @input="validate"
                        />
                        <span>
                          <img v-if="showPassword"
                            src="/static/images/icons/shaded-eye-icon.svg"
                            alt="eye-image"
                            id="togglePassword"
                            @click="switchVisibility()"
                          />
                          <img
                            v-if="!showPassword"
                            src="/static/images/icons/shaded-eye-slash-icon.svg"
                            alt="eye-slash-image"
                            id="togglePassword"
                            @click="switchVisibility()"
                          />
                        </span>
                        <div
                          class="col-md-12 col-xs-12 col-sm-12 alert alert-dismissible alert-danger"
                          id="divPasswordValidationResult"
                          v-if="!passwordError && user_data.password"
                        >
                          <span class="cancel-icon" @click='reset()'>&times;</span>
                          <p class="password-must">{{$t('passwordMust')}}:</p>
                          <ul class="password-cond">
                            <div v-if="counter < 3">
                              <div :key="item.message" v-for="item of verification">
                                <li
                                  id="capital"
                                  class="mandatory-field"
                                  v-if="!item.valid"
                                >{{item.message}}</li>
                              </div>
                            </div>
                            <li
                              id="length"
                              class="mandatory-field"
                              v-if="!isPasswordLength"
                            >{{$t('beAtLeast')}}</li>
                          </ul>
                        </div>
                        <div
                          class="custom-error-class"
                          v-if="!user_data.password && submitStatus"
                        >
                            {{$t('pleaseEnterAPassword')}}</div>
                      </div>
                    </div>
                    <div class="col-md-6 p-0 pl-12">
                      <p class="align-left mb-0 ft-14 field_head asterisk">{{$t('confirmPassword')}}</p>
                      <div class="form-group" :class="(submitStatus && !user_data.cpassword)  ? 'mb-12':''">
                        <input
                          id="cpassword"
                          class="form-control comn_border"
                          :class="(submitStatus && !user_data.cpassword)  ? 'invalid-border':''"
                          type="password"
                          maxlength="65"
                          :placeholder="$t('passwordPlaceholder')"
                          v-model="user_data.cpassword"
                          value
                        />
                        <span>
                          <img v-if="showConfirmPassword"
                            src="/static/images/icons/shaded-eye-icon.svg"
                            alt="eye-image"
                            id="togglePassword"
                            @click="switchConfirmVisibility()"
                          />
                          <img
                            v-if="!showConfirmPassword"
                            src="/static/images/icons/shaded-eye-slash-icon.svg"
                            alt="eye-slash-image"
                            id="togglePassword"
                            @click="switchConfirmVisibility()"
                          />
                        </span>
                        <div
                          class="custom-error-class"
                          v-if="!user_data.cpassword && submitStatus"
                        >
                            {{$t('pleaseConfirmYourPassword')}}</div>
                          <div
                            class="custom-error-class"
                            v-else-if="user_data.cpassword && user_data.password!=user_data.cpassword"
                          >
                            {{$t('passwordDoesNotMatch')}}.</div>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="row content">
                  <div class="col-md-6 p-0 pr-12">
                    <p class="align-left mb-0 ft-14 field_head">{{$t('jobTitle')}}</p>
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control comn_border"
                        :class="$v.user_data.title.$error ? 'invalid-border':''"
                        :placeholder="$t('jobTitlePlaceholder')"
                        v-model.trim="user_data.title"
                        maxlength="50"
                        @blur="$v.user_data.title.$touch()"
                      />
                      <div
                        class="custom-error-class"
                        v-if="!$v.user_data.title.isText && $v.user_data.title.$error"
                      >
                          {{ specialCharacterErrMsg }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Company Information -->
            <div class="">
              <h4 class="comp-info">{{$t('companyInformation')}}</h4>
              <div class="comapny-information">
                <div class="row content">
                  <div class="col-md-6 p-0 pr-12">
                    <p class="align-left mb-0 ft-14 field_head asterisk">{{$t('cnpj')}}</p>
                    <div class="form-group" :class="$v.user_data.cnpj.$error ||cnpjValidation||isValidCnpj==='invalid' ? 'mb-12':''">
                      <input
                        class="form-control comn_border"
                        v-model.trim="user_data.cnpj"
                        :class="$v.user_data.cnpj.$error ||cnpjValidation||isValidCnpj === 'invalid' ? 'invalid-border':''"
                        type="text"
                        :placeholder="$t('cnpjPlaceholder')"
                        :disabled="isFailure"
                        @input="cnpjMasking(user_data.cnpj)"
                        @blur="validateCnpj()"
                        maxlength="18"
                      />
                      <div v-if="$v.user_data.cnpj.$error">
                        <div
                          class="custom-error-class"
                          v-if="!$v.user_data.cnpj.required"
                        >
                            {{$t('completeRequiredField')}}</div>
                      </div>
                      <div v-if="cnpjValidation&&$v.user_data.cnpj.required" class="custom-error-class">
                            {{$t('enterValidCnpj')}}
                       </div>
                      <div
                          class="custom-error-class"
                          v-else-if="user_data.cnpj&&isValidCnpj==='invalid'"
                        >
                            {{$t('invalidCnpjNumber')}}</div>
                        <div
                          class="custom-success-class"
                          v-else-if="user_data.cnpj&&isValidCnpj==='valid'"
                        > <span class="">
                            </span>{{$t('validCnpjNumber')}}</div>
                      </div>
                  </div>
                  <div class="col-md-6 p-0 pl-12">
                    <p class="align-left mb-0 ft-14 field_head asterisk">{{$t('companyName')}}</p>
                    <div class="form-company-name form-group" :class="$v.user_data.company.$error ? 'mb-12':''">
                      <input
                        class="form-control comn_border"
                        :class="[$v.user_data.company.$error ? 'invalid-border':'', companyExists ? 'warning-border': '']"
                        type="text"
                        :placeholder="$t('companyNamePlaceholder')"
                        v-model.trim="user_data.company"
                        maxlength="50"
                        @blur="$v.user_data.company.$touch()"
                        @input="companyExists = false"
                      />
                      <div v-if="$v.user_data.company.$error">
                        <div
                          class="custom-error-class"
                          v-if="!$v.user_data.company.required"
                        >
                            {{$t('completeRequiredField')}}</div>
                        <div
                          class="custom-error-class"
                          v-else-if="!$v.user_data.company.minLength"
                        >
                            {{$t('min2CharactersRequired')}}.</div>
                        <div
                          class="custom-error-class"
                          v-else-if="!$v.user_data.company.isAlphaNum"
                        >
                            {{$t('firstCharacterShouldBeAlphaNumeric')}}</div>
                      </div>
                      <div v-if="companyExists">
                        <div
                          class="custom-warning-class"
                        >
                          {{$t('companyAlreadyExists')}}.</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row content">
                  <div class="col-md-6 p-0 pr-12">
                    <p class="align-left mb-0 ft-14 field_head asterisk">{{$t('streetAddress')}}</p>
                    <div class="form-group" :class="$v.user_data.card_address.$error ? 'mb-12':''">
                      <input
                        class="form-control comn_border"
                        :class="$v.user_data.card_address.$error ? 'invalid-border':''"
                        type="text"
                        size="60"
                         maxlength="500"
                        :placeholder="$t('streetAddressPlaceholder')"
                        v-model="user_data.card_address"
                        @blur="$v.user_data.card_address.$touch()"
                      />
                      <div v-if="$v.user_data.card_address.$error">
                        <div
                          class="custom-error-class"
                          v-if="!$v.user_data.card_address.required"
                        >
                            {{$t('completeRequiredField')}}</div>
                        <div
                          class="custom-error-class"
                          v-if="!$v.user_data.card_address.isAllowedCharacters && $v.user_data.card_address.$error"
                        >
                          {{ specialCharacterErrMsg }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 p-0 pl-12">
                    <p class="align-left mb-0 ft-14 field_head asterisk">{{$t('city')}}</p>
                    <div class="form-group" :class="$v.user_data.card_city.$error ? 'mb-12':''">
                      <input
                        class="form-control comn_border"
                        :class="$v.user_data.card_city.$error ? 'invalid-border':''"
                        type="text"
                        size="60"
                        maxlength="50"
                        :placeholder="$t('cityPlaceholder')"
                        v-model="user_data.card_city"
                        @blur="$v.user_data.card_city.$touch()"
                      />
                      <div v-if="$v.user_data.card_city.$error">
                        <div
                          class="custom-error-class"
                          v-if="!$v.user_data.card_city.required"
                        >
                            {{$t('completeRequiredField')}}</div>
                        <div
                          class="custom-error-class"
                          v-if="!$v.user_data.card_city.minLength"
                        >
                            {{$t('min3CharactersRequired')}}.</div>
                        <div
                          class="custom-error-class"
                          v-else-if="!$v.user_data.card_city.isAllowedCharacters"
                        >
                          {{ specialCharacterErrMsg }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row content">
                  <div class="col-md-6 p-0 pr-12">
                    <p class="align-left mb-0 ft-14 field_head asterisk">{{$t('state')}}</p>
                    <div class="form-group" :class="$v.user_data.card_state.$error ? 'mb-12':''">
                      <input
                        class="form-control comn_border"
                        :class="$v.user_data.card_state.$error ? 'invalid-border':''"
                        type="text"
                        size="60"
                        maxlength="50"
                        :placeholder="$t('statePlaceholder')"
                        v-model="user_data.card_state"
                        @blur="$v.user_data.card_state.$touch()"
                      />
                      <div v-if="$v.user_data.card_state.$error">
                        <div
                            class="custom-error-class"
                            v-if="!$v.user_data.card_state.required"
                          >
                            {{$t('completeRequiredField')}}</div>
                        <div
                          class="custom-error-class"
                          v-if="!$v.user_data.card_state.isText && $v.user_data.card_state.$error && $i18n.locale === 'Portuguese'"
                        >
                            Formato Inválido</div>
                        <div
                          class="custom-error-class"
                          v-if="!$v.user_data.card_state.isText && $v.user_data.card_state.$error && $i18n.locale === 'English'"
                        >
                            Invalid format</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 p-0 pl-12">
                    <p class="align-left mb-0 ft-14 field_head asterisk">{{$t('postCode')}}</p>
                    <div class="form-group" :class="$v.user_data.zipcode.$error ? 'mb-12':''">
                      <input
                        class="form-control comn_border"
                        :class="$v.user_data.zipcode.$error ? 'invalid-border':''"
                        type="text"
                        maxlength="15"
                        :placeholder="$t('postCodePlaceholder')"
                        v-model.trim="user_data.zipcode"
                        @blur="$v.user_data.zipcode.$touch()"
                      />
                      <div v-if="$v.user_data.zipcode.$error">
                        <div
                          class="custom-error-class"
                          v-if="!$v.user_data.zipcode.required"
                        >
                            {{$t('completeRequiredField')}}</div>
                        <div
                          class="custom-error-class"
                          v-if="!$v.user_data.zipcode.minLength"
                        >
                            {{$t('min2CharactersRequired')}}.</div>
                        <div
                          class="custom-error-class"
                          v-else-if="!$v.user_data.zipcode.isPostalCode && user_data.zipcode"
                        >
                            {{$t('validZipRequired')}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row content">
                  <div class="col-md-6 p-0 pr-12">
                    <p class="align-left mb-0 ft-14 field_head asterisk">{{$t('country')}}</p>
                    <div class="form-group" :class="$v.user_data.country.$error ? 'mb-12':''">
                      <div class="custom-dropdown">
                        <multiselect
                        class="product-class-ellipsis multiselect-single-dropdown"
                        :class="$v.user_data.country.$error ? 'invalid-dropdown-border':''"
                        :placeholder="$t('selectCountry')"
                        label="country_name"
                        openDirection="below"
                        v-model="user_data.country"
                        :show-labels="false"
                        :options="countriesList.map(type => type.alpha_three_code)"
                        :custom-label="opt => countriesList.find(x => x.alpha_three_code === opt).country_name"
                      >
                      <span slot="noResult">{{ $t('noElementsFound') }}</span>
                      </multiselect>
                      </div>
                      <div v-if="$v.user_data.country.$error">
                        <div
                          class="custom-error-class pt-21"
                          v-if="!$v.user_data.country.required && $v.user_data.country.$error"
                        >
                            {{$t('completeRequiredField')}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 p-0 pl-12">
                     <p class="align-left mb-0 ft-14 field_head asterisk">{{$t('companyType')}}</p>
                    <div class="form-group mb-60">
                      <div class="custom-dropdown">
                        <multiselect
                          class="product-class-ellipsis multiselect-single-dropdown"
                          :class="$v.user_data.area_responsible_id.$error ? 'invalid-dropdown-border':''"
                          :show-labels="false"
                          openDirection="below"
                          :allow-empty="false"
                          :searchable="true"
                          :placeholder="$t('companyTypePlaceholder')"
                          v-model="user_data.area_responsible_id"
                          :options="responsibilitiesList.map(type => type.id)"
                          :custom-label="opt => responsibilitiesList.find(x => x.id === opt).responsibility_name"
                        >
                      <span slot="noResult">{{ $t('noElementsFound') }}</span>
                      </multiselect>
                      </div>
                      <div v-if="$v.user_data.area_responsible_id.$error">
                        <div
                          class="custom-error-class pt-21"
                          v-if="!$v.user_data.area_responsible_id.required"
                        >
                            {{$t('completeRequiredField')}}</div>
                      </div>
                    </div>
                      <!-- <p class="align-left mb-0 ft-14 field_head">{{ $t('headquarterAddress') }}</p>
                      <div class="form-group mb-14" :class="$v.user_data.headQuarterAddress.$error ? 'mb-12' : ''">
                        <input
                          class="form-control comn_border"
                          :class="$v.user_data.headQuarterAddress.$error ? 'invalid-border' : ''"
                          type="text"
                           maxlength="500"
                          :placeholder="$t('enterHeadquarterAddress')"
                          v-model.trim="user_data.headQuarterAddress"
                          @blur="$v.user_data.headQuarterAddress.$touch()"
                          @input="cnpjAddress=false"
                        />
                        <div v-if="$v.user_data.headQuarterAddress.$error">
                        <div
                          class="custom-error-class"
                          v-if="!$v.user_data.headQuarterAddress.isAllowedCharacters && $v.user_data.headQuarterAddress.$error"
                        >
                            {{ specialCharacterErrMsg }}</div>
                      </div>
                      </div>
                      <div class="d-flex col-gap-8">
                      <div class="checkbox-wrapper pl-4" :class="{'disable-dropdown':!isValidCnpj||isValidCnpj==='invalid'}">

                      <label class="custom-checkbox">
                        <input type="checkbox" @click="fillCnpjAddress()" v-model="cnpjAddress" :disabled="!isValidCnpj ||isValidCnpj==='invalid'"/>
                        <span class="select-check"></span>
                      </label>
                    </div>
                      <div class="cnpj-address">{{ $t('cnpjAddress') }}</div>

                    </div> -->
                  </div>
                </div>
                <!-- <div class="row content">
                  <div class="col-md-6 p-0 pr-12">
                    <p class="align-left mb-0 ft-14 field_head asterisk">{{$t('companyType')}}</p>
                    <div class="form-group mb-60">
                      <div class="custom-dropdown">
                        <multiselect
                          class="product-class-ellipsis multiselect-single-dropdown"
                          :class="$v.user_data.area_responsible_id.$error ? 'invalid-dropdown-border':''"
                          :show-labels="false"
                          openDirection="below"
                          :allow-empty="false"
                          :searchable="true"
                          :placeholder="$t('companyTypePlaceholder')"
                          v-model="user_data.area_responsible_id"
                          :options="responsibilitiesList.map(type => type.id)"
                          :custom-label="opt => responsibilitiesList.find(x => x.id === opt).responsibility_name"
                        >
                      <span slot="noResult">{{ $t('noElementsFound') }}</span>
                      </multiselect>
                      </div>
                      <div v-if="$v.user_data.area_responsible_id.$error">
                        <div
                          class="custom-error-class pt-21"
                          v-if="!$v.user_data.area_responsible_id.required"
                        >
                            {{$t('completeRequiredField')}}</div>
                      </div>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-12 pt-33 pl-0">
          <div class="col-sm-12 p-0 check-content checkbox-container cust_checkbox">
            <div class="checkbox-wrapper">
              <label class="custom-checkbox">
                <input type="checkbox" @click="checkTerms" v-model="user_data.terms" />
                <span class="select-check"></span>
              </label>
            </div>
            <span class="terms-conditions">
              {{$t('registerAgreementLine1')}} <span class="scd" @click="openSaasModal('sass')">{{$t('registerAgreementLineColorChanged')}}</span> {{$t('andThe')}} <span class="scd" @click="openSaasModal('termsOfUse')">{{$t('registerAgreementLine2')}}</span>
            </span>
          </div>
          <div class="col-sm-12 p-0 check-content checkbox-container cust_checkbox pt-18">
            <div class="checkbox-wrapper">
              <label class="custom-checkbox">
                <input type="checkbox" @click="checkPrivacyNotice" v-model="user_data.privacyNotice" />
                <span class="select-check"></span>
              </label>
            </div>
            <span class="terms-conditions">
              {{$t('privacyNoticeAcknowledge')}} <span class="privacy-notice" @click="openSaasModal('privacyPolicy')">{{$t('privacyNotice')}}</span>.
            </span>
          </div>
          <div class="col-sm-12 p-0">
            <button class="create_account_button"
            type="submit" value="validate"
            id="confirmButton"
            :disabled="submitStatus === 'PENDING'"
             >
             {{$t('createAccount')}}</button>
          </div>

          <div class="col-sm-12 existing-acct">
              {{$t('alreadyHaveAnAccount')}}?
              <router-link to="/login">{{$t('login')}}</router-link>
            </div>
        </div>
      </form>
      </div>
    <verification-popup :successMessage="successMessage"></verification-popup>
    </div>
  </div>
    <TermsOfStatus :termsOfStatus ="agreementType"/>
    <!-- <loader :loadingStatus="loaderStatus"></loader> -->

  </div>
</template>

<script>
import $ from 'jquery';
import * as moment from 'moment';
import * as freeDomainNames from 'free-email-domains';
import { isValidCNPJ } from '@brazilian-utils/brazilian-utils';
import {
  getCountries,
  postRegister,
  GetResponsibilities,
  validateUserInfo,
  checkCompanyName,
  checkCnpj,
} from '../../apis/register';
import {
  isAllowedCharacters, // eslint-disable-line no-unused-vars
  isAlphaNum, // eslint-disable-line no-unused-vars
  isNumber, // eslint-disable-line no-unused-vars
  isPostalCode, // eslint-disable-line no-unused-vars
  validateData,
  isContainsUpperCase,
  isContainsLowerCase,
  isContainsDigit,
  isContainsSpecialChar,
  isValidMail, // eslint-disable-line no-unused-vars
  checkConditions,
  isText, // eslint-disable-line no-unused-vars
} from './validator';
import verificationPopup from '../VerificationLink/VerificationPopup.vue';
import EventBus from '../../utils/event-bus';
import TermsOfStatus from '../Login/TermsOfStatus.vue';
import LoginHeader from '../Login/LoginHeaderNew.vue';
// import Loader from '../UIComponents/Loader.vue';

export default {
  components: {
    TermsOfStatus,
    verificationPopup,
    LoginHeader,
    // Loader
  },
  data() {
    return {
      showPassword: true,
      showConfirmPassword: true,
      agreementType: '',
      selectedLanguageLabel: '',
      languages: ['English', 'Portuguese'],
      user_data: {
        first_name: '',
        last_name: '',
        email: '',
        title: '',
        company: '',
        cnpj: '',
        country: '',
        mobile: '',
        card_address: '',
        card_city: '',
        card_state: '',
        zipcode: '',
        password: '',
        cpassword: '',
        area_responsible_id: null,
        terms: false,
        repClient: 0,
        consultingClient: 0,
        // headQuarterAddress: '',
        privacyNotice: false,
      },
      clear_user_data: {
        first_name: '',
        last_name: '',
        email: '',
        title: '',
        company: '',
        cnpj: '',
        country: '',
        mobile: '',
        card_address: '',
        card_city: '',
        card_state: '',
        zipcode: '',
        password: '',
        cpassword: '',
        area_responsible_id: null,
        terms: true,
        repClient: 0,
        consultingClient: 0,
        // headQuarterAddress: '',
      },
      isFreeDomain: false,
      successMessage: '',
      countriesList: [],
      responsibilitiesList: [],
      btnTxt: 'Complete and Create account',
      submitStatus: null,
      termsErr: false,
      specialCharacterErrMsg:
        'The following characters are not allowed: * ? < > ! @ # $ “ % ^',
      counter: 0,
      verification: [
        { message: 'Have at least one capital letter', valid: false },
        { message: 'Have at least one lowercase letter', valid: false },
        { message: 'Have at least one number', valid: false },
        { message: 'Have at least one special character !@#$.,+=( )_%^&*', valid: false },
      ],
      isPasswordLength: false,
      passwordError: false,
      companyExists: false,
      companyInfoActive: false,
      emailInfoActive: false,
      currLang: '',
      invalidMessage: 'Invalid format',
      show_burger_icon: true,
      isValidCnpj: '',
      // loaderStatus: false
      isFailure: false,
      // cnpjAddress: false,
      cnpjInformation: '',
      cnpjValidation: false
    };
  },
  validations: {
    user_data: validateData,
  },
  async created() {
    this.currLang = this.$i18n.locale;
    if (this.$i18n.locale === 'Portuguese') {
      this.languages = ['Inglês', 'Português'];
      this.selectedLanguageLabel = 'Português';
      this.verification = [
        { message: 'Ter pelo menos uma letra maiúscula', valid: false },
        { message: 'Ter pelo menos uma letra minúscula', valid: false },
        { message: 'Ter pelo menos um número', valid: false },
        { message: 'Ter pelo menos um caractere especial !@#$.,+=( )_%^&*', valid: false },
      ];
    } else {
      this.selectedLanguageLabel = 'English';
      this.verification = [
        { message: 'Have at least one capital letter', valid: false },
        { message: 'Have at least one lowercase letter', valid: false },
        { message: 'Have at least one number', valid: false },
        { message: 'Have at least one special character !@#$.,+=( )_%^&*', valid: false },
      ];
    }
    EventBus.$on('languageChanged', this.changeLanguage);
    await this.loadCountries();
    await this.loadResponsibilites();
    // await this.validateCnpj();
    if (sessionStorage.getItem('userData')) {
      this.user_data = JSON.parse(sessionStorage.getItem('userData'));
      this.validate();
    }
    if (this.$route.query.plan === 'repclients' || this.$route.query.plan === 'consultingclients') {
      this.user_data.plan = this.$route.query.plan;
    }
    Object.keys(this.user_data).forEach((key) => {
      if (key === 'repClient' || key === 'consultingClient') this.user_data[key] = 0;
      else if (key === 'terms') this.user_data[key] = false;
      else if (key === 'area_responsible_id') this.user_data[key] = null;
      else this.user_data[key] = '';
    });
  },
  beforeDestroy() {
    EventBus.$off('languageChanged', this.changeLanguage);
  },
  methods: {
    // fillCnpjAddress() {
    //   this.user_data.headQuarterAddress = !this.cnpjAddress ? `${this.cnpjInformation.company}, ${this.cnpjInformation.street}, ${this.cnpjInformation.city}, ${this.cnpjInformation.state}, ${this.cnpjInformation.postalCode}, ${this.cnpjInformation.country}` : '';
    // },
    // changeLanguage(currLang) {
    //   this.currLang = currLang;
    // },
    openModal(data) {
      console.log('openSaasModal');
      this.agreementType = data;
      $('#agreements').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
    closeTermsErr() {
      this.termsErr = false;
    },

    cnpjMasking(cnpj) {
      // if (this.cnpjAddress) {
      //   this.cnpjAddress = false;
      //   this.user_data.headQuarterAddress = '';
      // }
      this.cnpjValidation = false;
      this.isValidCnpj = '';
      cnpj = cnpj.replace(/\D/g, ''); // Removes everything that is not a digit
      cnpj = cnpj.replace(/^(\d{2})(\d)/, '$1.$2'); // Place dot between second and third digits
      cnpj = cnpj.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3'); // Place dot between fifth and sixth digits
      cnpj = cnpj.replace(/\.(\d{3})(\d)/, '.$1/$2'); // Puts a slash between the eighth and ninth digits
      cnpj = cnpj.replace(/(\d{4})(\d)/, '$1-$2'); // Puts a hyphen after the four-digit block
      if (this.user_data.cnpj.length === 18) this.cnpjValidation = false;
      this.user_data.cnpj = cnpj;
      return cnpj;
    },

    async validateCnpj() {
      this.cnpjInformation = '';
      this.$v.user_data.cnpj.$touch();
      if (!this.$v.user_data.cnpj.required) {
        this.cnpjValidation = false;
        return;
      }
      if (this.user_data.cnpj.length !== 18) {
        this.cnpjValidation = true;
        return;
      }
      if (this.isFailure) return;
      if (this.user_data.cnpj && this.user_data.cnpj.length === 18) {
        // this.loaderStatus = true;
        this.cnpjValidation = false;
        let response = '';
        this.isFailure = true;
        response = await checkCnpj(this.user_data.cnpj.replace(/[./-]/g, ''));
        // this.loaderStatus = false;
        if (response.status === 200) {
          this.isFailure = false;
          this.isValidCnpj = 'valid';
          const cnpjInfo = response.data;
          this.cnpjInformation = cnpjInfo;
          this.user_data.company = cnpjInfo.company;
          this.user_data.card_state = cnpjInfo.state;
          this.user_data.card_city = cnpjInfo.city;
          this.user_data.card_address = cnpjInfo.street;
          this.user_data.zipcode = cnpjInfo.postalCode;
          const countryCode = this.countriesList.find(((item) => item.country_code === cnpjInfo.countryCode));
          this.user_data.country = countryCode.alpha_three_code;
        } else {
          const cnpjValid = isValidCNPJ(this.user_data.cnpj);
          this.isFailure = false;
          this.isValidCnpj = cnpjValid ? 'valid' : 'invalid';
          this.user_data.company = '';
          this.user_data.card_state = '';
          this.user_data.card_city = '';
          this.user_data.card_address = '';
          this.user_data.zipcode = '';
          this.user_data.country = '';
        }
      } else {
        this.user_data.company = '';
        this.user_data.card_state = '';
        this.user_data.card_city = '';
        this.user_data.card_address = '';
        this.user_data.zipcode = '';
        this.user_data.country = '';
      }
    },
    openSaasModal(data) {
      this.agreementType = data;
      $('#agreements').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
    showImage(event) {
      event.preventDefault();
      const result = $('#burger').hasClass('collapsed');
      this.show_burger_icon = !this.show_burger_icon;
      if (result) $('#burger').removeClass('collapsed');
    },
    getFullYear() {
      return moment().format('YYYY');
    },
    async changeLanguage(language) {
      if (['Portuguese', 'Português'].includes(language)) {
        this.selectedLanguageLabel = 'Português';
        this.$i18n.locale = 'Portuguese';
        this.verification = [
          { message: 'Ter pelo menos uma letra maiúscula', valid: false },
          { message: 'Ter pelo menos uma letra minúscula', valid: false },
          { message: 'Ter pelo menos um número', valid: false },
          { message: 'Ter pelo menos um caractere especial !@#$.,+=( )_%^&*', valid: false },
        ];
        // if (this.termsErr) {
        //   this.termsErr = 'E-mail já registrado.';
        // }
        // EventBus.$emit('languageChanged', this.$i18n.locale);
      } else {
        this.selectedLanguageLabel = 'English';
        this.languages = ['English', 'Portuguese'];
        this.$i18n.locale = 'English';
        this.verification = [
          { message: 'Have at least one capital letter', valid: false },
          { message: 'Have at least one lowercase letter', valid: false },
          { message: 'Have at least one number', valid: false },
          { message: 'Have at least one special character !@#$.,+=( )_%^&*', valid: false },
        ];
        // if (this.termsErr) {
        // this.termsErr = 'Email already registered.';
        // }
        // EventBus.$emit('languageChanged', this.$i18n.locale);
      }
      await this.loadCountries();
      await this.loadResponsibilites();
    },
    switchVisibility() {
      this.showPassword = !this.showPassword;
      const resetPasswordField = document.querySelector('#password');
      if (resetPasswordField.getAttribute('type') === 'password') {
        resetPasswordField.setAttribute('type', 'text');
      } else {
        resetPasswordField.setAttribute('type', 'password');
      }
    },
    switchConfirmVisibility() {
      this.showConfirmPassword = !this.showConfirmPassword;
      const confirmPasswordField = document.querySelector('#cpassword');
      if (confirmPasswordField.getAttribute('type') === 'password') {
        confirmPasswordField.setAttribute('type', 'text');
      } else {
        confirmPasswordField.setAttribute('type', 'password');
      }
    },
    checkEmailIsValid() {
      this.$v.user_data.email.$touch();
      if (process.env.VUE_APP_MODE === 'production' && this.user_data.email.includes('@')) {
        const emailToSpit = this.user_data.email.split('@');
        const domainName = emailToSpit[emailToSpit.length - 1];
        this.isFreeDomain = this.$v.user_data.email.isValidMail && freeDomainNames.default.includes(domainName);
      }
    },
    async checkCompanyName() {
      if (!this.$v.user_data.company.$error) {
        this.companyExists = await checkCompanyName({ company_name: this.user_data.company });
      }
    },
    dismissTab() {
      $('div.emergo-contact').remove();
    },
    reset() {
      $('#divPasswordValidationResult').hide();
    },
    validate() {
      this.counter = 0;
      if (this.user_data.password) {
        this.verification[0].valid = isContainsUpperCase(
          this.user_data.password,
        );
        this.verification[1].valid = isContainsLowerCase(
          this.user_data.password,
        );
        this.verification[2].valid = isContainsDigit(this.user_data.password);
        this.verification[3].valid = isContainsSpecialChar(
          this.user_data.password,
        );
      }
      this.counter = checkConditions(this.user_data.password);
      this.isPasswordLength = false;
      if (this.user_data.password.length >= 10) this.isPasswordLength = true;

      this.passwordError = false;
      if (this.isPasswordLength && this.counter >= 3) {
        this.passwordError = true;
      }
    },
    checkTerms() {
      this.termsErr = '';
      if (this.user_data.terms) {
        this.termsErr = this.$i18n.locale === 'Portuguese' ? 'Por favor selecione as caixas de seleção de confirmação' : 'Please select the acknowledgement checkboxes';
      }
    },
    checkPrivacyNotice() {
      this.termsErr = '';
      if (this.user_data.privacyNotice) {
        this.termsErr = this.$i18n.locale === 'Portuguese' ? 'Por favor selecione as caixas de seleção de confirmação' : 'Please select the acknowledgement checkboxes';
      }
    },
    async submit() {
      this.$v.$touch();
      this.termsErr = '';
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR';
      } else if (
        !this.passwordError
        || this.user_data.password !== this.user_data.cpassword
        || !this.user_data.cpassword
      ) {
        this.submitStatus = 'ERROR';
      } else if (!this.user_data.terms || !this.user_data.privacyNotice) {
        this.termsErr = this.$i18n.locale === 'Portuguese' ? 'Por favor selecione as caixas de seleção de confirmação' : 'Please select the acknowledgement checkboxes';
        this.btnTxt = this.$i18n.locale === 'Portuguese' ? 'Confirmar e criar conta' : 'Confirm and Create account';
      } else if (this.isFreeDomain) {
        this.submitStatus = 'ERROR';
      } else if (this.isValidCnpj === 'invalid' || !this.isValidCnpj) {
        this.submitStatus = 'ERROR';
      } else {
        this.submitStatus = 'PENDING';
        const validatedata = {
          email: this.user_data.email,
        };
        if (this.user_data.plan) validatedata.plan = this.user_data.plan;
        const result = await validateUserInfo(validatedata);
        if (result && !result.status) {
          this.termsErr = this.$i18n.locale === 'Portuguese' ? 'E-mail já registrado.' : 'Email already registered.';
          this.submitStatus = null;
        } else if (result && result.status) {
          this.submitStatus = 'PENDING';
          const country = this.countriesList.find(
            (item) => item.alpha_three_code === this.user_data.country,
          ) || {};
          const data = this.user_data;
          const postData = {
            card_location: country ? country.country_name : '',
            alpha_three_code: country ? country.alpha_three_code : '',
            area_responsible_id: data.area_responsible_id,
            title: data.title,
            card_postal: data.zipcode,
            card_state: data.card_state,
            card_city: data.card_city,
            card_address: data.card_address,
            phone: data.mobile,
            company: data.company,
            cnpj: data.cnpj.replace(/[./-]/g, ''),
            email: data.email,
            first_name: data.first_name,
            last_name: data.last_name,
            password: data.password,
            terms: data.terms,
            plan: data.plan,
            // headQuarterAddress: data.headQuarterAddress,
          };
          Object.keys(postData).forEach((key) => {
            if (postData[key] === null || postData[key] === undefined || postData[key] === '') delete postData[key];
          });
          this.registrationFail = false;
          this.termsErr = '';
          this.btnTxt = 'Submitting Form...';
          const response = await postRegister(this.$i18n.locale, postData);
          this.btnTxt = 'Complete and Create account';
          this.submitStatus = null;
          if (response) {
            if (response.status) {
              this.clearData();
              this.successMessage = response.message;
              $('#successMsgModal').modal('show');
            } else {
              this.termsErr = response.message;
              console.log('final', this.termsErr);
            }
          }
        }
      }
    },
    clearData() {
      this.user_data = {
        first_name: '',
        last_name: '',
        email: '',
        title: '',
        company: '',
        cnpj: '',
        country: '',
        mobile: '',
        card_address: '',
        card_city: '',
        card_state: '',
        zipcode: '',
        password: '',
        cpassword: '',
        area_responsible_id: null,
        terms: false,
        repClient: 0,
        consultingClient: 0,
        // headQuarterAddress: '',
      };
      this.$v.$reset();
      this.validate();
    },
    async loadCountries() {
      this.countriesList = await getCountries(this.$i18n.locale);
    },
    async loadResponsibilites() {
      this.responsibilitiesList = await GetResponsibilities(this.$i18n.locale);
    },
  },
  watch: {
    user_data: {
      deep: true,
      handler(userData) {
        sessionStorage.setItem('userData', JSON.stringify(userData));
      },
    },
  },
};
</script>
<style scoped>
.custom-checkbox input[type='checkbox']:checked ~ .select-check {
  background-size: 13px 18px !important;
}
.pl-4 {
  margin-left:4px
}
.mb-14 {
  margin-bottom:14px !important
}
.cnpj-address{
  color:  #333;
  font-family: Open Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
}
.col-gap-8 {
  column-gap: 8px;
}
.custom-checkbox input[type='checkbox']:checked ~ .select-check {
  background-color: #00518A;
}
.privacy-notice {
  font-weight: 600;
  color: #00518A;
  cursor: pointer;
  font-size: 18px;
}
.pt-18 {
  padding-top: 18px;
}
.registration-wrapper {
  padding: 0px 160px;
}
.burger_icon{
  height: 22px;
  width: 22px;
}
.close_icon{
  height:20px;
  width: 20px;
}
.mt-32{
  margin-top: 32px;
}
.mt-23{
  margin-top: 23px !important;
}
.register-wrapper::-webkit-scrollbar {
  width: 6px;
  /* max-height: 50%;
  height: 50%; */
}
.register-wrapper::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
  /* height: 30%; */
}
.register-wrapper::-webkit-scrollbar-track-piece:end {
  margin-bottom: 20px;
}
.register-wrapper::-webkit-scrollbar-track-piece:start {
  margin-top: 20px;
}
.pr-46{
  padding-right: 46px;
}
.pr-24{
  padding-right: 24px;
}
.max-height::-webkit-scrollbar {
  width: 6px;
}
.max-height::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
}
.max-height::-webkit-scrollbar-track{
  /* border-radius: 15px; */
   margin: 40px;
  /* box-shadow: inset 7px 10px 12px #f0f0f0; */
 }
/* .team-wrapper::-webkit-scrollbar-track-piece:end {
  margin-bottom: 20px;
}
.team-wrapper::-webkit-scrollbar-track-piece:start {
  margin-top: 20px;
} */
.mb-12{
  margin-bottom: 12px !important;
}
.mb-60{
  margin-bottom: 60px !important;
}
.pt-33 {
  padding-top: 33px;
}
.pt-21{
  padding-top: 13px !important;
}
.checkbox-error-section{
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #C01B21;
  margin-bottom: 16px;
}
.checkbox-error{
    padding: 7px 0px 7px 0px;
    background: #C01B21;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color:  #FFFFFF;
}
.check-box-error-info{
  width: 20px;
  height: 20px;
  margin: 6px 0px 6px 16px;
}
.chechBox-error-cancel-icon{
  margin-right: 16px;
  cursor: pointer;
}
/* Tablet & mobile language dropdown */
.account-info{
  padding-bottom: 30px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 27px;
  color: #333333;
}
.pr-10 {
  padding-right: 10px;
}
.lang-dropdown{
    width: 170px;
}
.lang-dropdown .multiselect--active
  >>> .multiselect__content-wrapper::before{
    content: '';
    position: absolute;
    top: 0;
    left: 10px;
    border: 0.5px solid #333333;
    opacity:0.5;
    width: 85%;
}
.lang-dropdown .multiselect-single-dropdown.multiselect--active::before {
  content: none;
}
.lang-dropdown .multiselect-single-dropdown
>>> .multiselect__content-wrapper ul li:first-child{
  margin-top: 6px !important;
}
.lang-dropdown .multiselect-single-dropdown
>>> .multiselect__select{
  padding-right: 12px;
  padding-top: 7px !important;
  padding-bottom: 4px;
}
.lang-dropdown .multiselect--active
>>> .multiselect__select{
  padding-top: 5px !important;
  padding-bottom: 7px;
}
.lang-dropdown .multiselect-single-dropdown
  >>> .multiselect__placeholder{
    color: #333333;
  }
  .lang-dropdown .multiselect--active
  >>> .multiselect__placeholder{
    display: block !important;
  }
  .lang-dropdown .multiselect-single-dropdown
  >>> .multiselect__tags{
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    background: #FBFAFF;
  }
  .lang-dropdown .multiselect-single-dropdown
  >>> .multiselect__select:before{
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    border: 1px solid #333333;
    border-width: 0 1px 1px 0;
    display: inline-block;
    padding: 5px;
    top: 0px;
    content: "";
  }
  .lang-dropdown .multiselect--active:not(.multiselect--above)
  >>> .multiselect__tags{
    /* border-radius:0px !important; */
    border-top-left-radius: 3px !important;
    border-top-right-radius: 3px !important;
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-bottom: none !important;
  }
  .lang-dropdown .multiselect--active
  >>> .multiselect__content-wrapper{
    border-top: none !important;
    margin-top: 0px !important;
  }
  .lang-dropdown .multiselect-single-dropdown
  >>> .multiselect__content-wrapper{
    margin-top: 0px !important;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .lang-dropdown .multiselect--active
  >>> .multiselect__tags{
    border-radius: 0px !important;
    border-bottom: 0px;
  }
  .lang-dropdown .multiselect--active
  >>> .multiselect__option:hover{
    border:1px solid #0A99ff !important;
  }
  .lang-dropdown .multiselect--active
  >>> .multiselect__option.multiselect__option--highlight{
    border:1px solid #0A99ff !important;
    font-weight: 600 !important;
  }
  .lang-dropdown .multiselect--active
  >>> .multiselect__option.multiselect__option--highlight span{
    font-weight: 600 !important;
  }
.mb-38 {
  margin-bottom: 38px;
}
.footer_content > .footer-copyright {
  margin-bottom: 0px;
}
.footer-copyright {
  color: #333333;
  font-family: 'Open Sans';
  font-size: 16px;
  /* padding: 5px; */
  font-weight: 300;
  margin-top: 0 !important;
  padding-top: 10px !important;
  padding-bottom: 18px !important;
}
.footer-copyright > li {
  padding-right: 14px;
}
.footer_content {
  text-align: center;
  border-top: 0.5px solid #BDBDBD;
}
.footer_content > ul {
  white-space: nowrap;
  list-style: none;
  margin: 10px 10px 5px 10px;
}
.footer_content > ul > li {
  display: inline;
}
.footer_menu {
  padding: 12px 0px 0px 0px;
}
.footer_menu > li {
  cursor: pointer;
  margin-right: 40px;
  padding-right: 40px;
  color: #01518a;
  font-family: 'Open Sans';
  font-size: 18px;
  font-weight: 700;
  padding-bottom: 5px;
}
.footer_menu > li > a:hover {
  border-bottom: 2px solid white;
}
/* .userProfileDropDown{
  padding-top: 18px;
} */
.language_dropdown{
  display: flex;
    align-items: center;
    justify-content: space-between;
}
.language_dropdown .languagePlaceholder{
    color: #01518a;
      padding-left: 28px;
      font-weight: 400;
      font-size: 14px;
      font-family: 'Open Sans';
      font-style: normal;
      padding-top: 12px;
      line-height: 19px;
}
.language_dropdown button{
  background-color: transparent !important;
    padding: 0px;
    border: none;
}
.languagesList button{
  background-color: transparent !important;
    padding: 0px;
    border: none;
}
.downCarret,
  .upCarret{
    width: 19px;
    height: 19px;
  }
  .userProfileDropDown .language_dropdown .carretSection span button[aria-expanded="true"] img.upCarret{
    display: inline-block;
  }
  .userProfileDropDown .language_dropdown .carretSection span button[aria-expanded="true"] img.downCarret{
    display: none;
  }
  .userProfileDropDown .language_dropdown .carretSection span button img.downCarret {
    display: inline-block;
    transform: rotate(180deg);
  }
  .userProfileDropDown .language_dropdown .carretSection span button img.upCarret{
    display: none;
  }
  .languagesList ul li button .li-title{
    color: #01518a;
    /* padding-left: 28px; */
    font-weight: 400;
    font-size: 14px;
    font-family: 'Open Sans';
      font-style: normal;
      line-height: 19px;
  }
  .languagesList ul li button{
    padding-left: 0px !important;
  }
  .languagesList ul li .settings-title{
    padding-left: 0px !important;
    /* padding-top: 18px; */
  }
  .pt-14 {
    padding-top: 14px !important;
  }
  .languagesList ul{
    padding-left: 28px;
  }
  .portugueseItem{
    /* padding-top: 0px !important; */
    padding-bottom: 0px !important;
  }
  .carretSection{
    padding-right: 29px;
    padding-top: 15px;
  }
  /* Desktop Language dropdown  */
  .mainHeaderNav{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 21px;
    margin-right: 9px;
  }
  .languageItem{
    margin-right: auto;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 19px;
    color: #01518a;
    padding-top: 10px !important;
  }
  .open .dropdownValue .value .caret{
    transform: rotate(225deg);
  }
  .caret{
    -webkit-transform: rotate(45deg);
    border: 1px solid #333333;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 5px;
    margin-bottom: 5px;
    /* top: 8px;
    right: 13px;
    position: absolute; */
    content: "";
    transform: rotate(45deg);
  }
  @media (max-width: 1024px) {
  .mainHeaderNav{
    display: none;
  }
}
  /* .dropdown .value span button{
    background-color: transparent !important;
    padding: 0px;
    border: none;
  }
  .dropdown .value span button[aria-expanded="true"] img.upCarret{
    display: inline-block;
  }
  .dropdown .value span button[aria-expanded="true"] img.downCarret{
    display: none;
  }
  .dropdown .value span button img.downCarret {
    display: inline-block;
    transform: rotate(180deg);
  }
  .dropdown .value span button img.upCarret{
    display: none;
  } */
  .dropdown {
  width: 100%
}
.dropdownValue {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border: 1px solid black !important;
  padding: 5px 10px !important;
  width: 100%;
  background: white;
}
.dropdownValue .value {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}
.dropdownValue:focus {
  background: white;
}
.dropdownValue:hover {
  background: white;
}
.open .value .caret{
  margin-top: 10px;
}
.open>.dropdown-toggle.btn-default {
    color: #333333;
    background-color: #ffffff;
    background-image: none;
    /* border-color: #adadad; */
}
.dropdown-toggle.btn-default:hover,
.open>.dropdown-toggle.btn-default:focus,
.open>.dropdown-toggle.btn-default:hover {
    color: #333333;
    background-color: #ffffff;
    /* border-color: #8c8c8c; */
  }
  .open .dropdown-menu li:hover {
    border:1px solid #0A99ff !important; ;
  }
.open .dropdownValue {
  border-bottom: 0px !important;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
.open .dropdownValue .value {
  /* border-bottom: 1px solid black; */
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  /* background-color: red; */
}

.open .dropdown-menu {
  border: 1px solid black;
  border-radius: 0px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  margin: 0;
  padding-top: 0px !important;
  border-top: 0px;
  min-width: none;
  width: 100%;

}
.open .dropdown-menu li:first-child {
  /* border-top: 1px solid black; */
  margin-bottom: 5px;
}
.open .value{
  border-bottom: 1px solid black !important;
  margin-top: 3px;
    padding-bottom: 5px;
}
.open .dropdown-menu li {
  /* margin-left: 12px; */
  padding-left: 12px;
    /* margin-top: 10px; */
    padding-top: 10px;
  /* margin-top: 10px; */
  font-family: 'Open Sans';
font-style: normal;
font-weight: 300;
font-size: 18px;
line-height: 25px;
color: #333333;
}
.open .dropdown-menu::after {
  content: none !important
}
.dropdownValue::after {
  margin-left: auto;
}
/* Multiselect country & company styles */
/* .multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
  padding-top: 0px !important;
} */
.product-class-ellipsis.multiselect-single-dropdown
>>> .multiselect__single,
.accredited-by-ellipsis.multiselect-single-dropdown
>>> .multiselect__single{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 450px;
  margin-bottom: 0px;
}
.multiselect-single-dropdown.multiselect--active::before{
  content: none;
}
.multiselect--active
  >>> .multiselect__tags{
    border-radius: 3px !important;
    border-bottom: none;
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-top: 1px solid #CCCCCC;
    border-right: 1px solid #CCCCCC;
    border-left: 1px solid #CCCCCC;
  }
  .multiselect--active >>> .multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected.multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected:after{
    content: none !important;
  }
.multiselect{
  min-height: 36px;
}
  .multiselect-single-dropdown
  >>> .multiselect__tags{
    border-radius: 3px;
    height: 36px;
    padding: 9px 40px 11px 11px;
    border: 1px solid #4D4D4D !important;
    /* border: 1px solid #CCCCCC !important; */
  }
  .multiselect-single-dropdown
  >>> .multiselect__select{
    padding-top: 9px !important;
  }
  .multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
    padding-top:8px !important;
  }
  .multiselect-single-dropdown.multiselect--disabled {
        background: #ededed;
        pointer-events: none;
        opacity: 0.4;
        /* border: 1px solid #4D4D4D; */

  }
  .multiselect-single-dropdown
  >>> .multiselect__select:before{
    /* border: 1px solid #000000;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg); */
    /* border: 1px solid #0b3c61; */
    /* border-width: 0 1px 1px 0; */
    /* display: inline-block; */
    /* padding: 5px; */
    /* top: 0px;
    content: "";
    border-width: 7px 7px 0;
    padding: 0px !important; */
    position: relative;
    right: 0;
    /* top: 65%; */
    color: #4D4D4D;
    margin-top: 4px;
    border-color:  #4D4D4D transparent transparent;
    border-style: solid;
    border-width: 7px 7px 0;
    content: "";
    transform: rotate(0) !important;
    /* -webkit-transform: rotate(45deg); */
    /* border: 1px solid #0b3c61;
    border-width: 0 2px 2px 0;
    display: inline-block; */
    padding: 0px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__option:hover{
    background: #FFFFFF !important;
  }
  .multiselect--active
  >>> .multiselect__select{
    padding-bottom: 6px !important;
    padding-top: 4px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper .multiselect__option--highlight.multiselect__option--selected{
    /* background: #e6e6e6 !important; */
    /* font-weight: 600 !important; */
    border: 1px solid #0A99FF;
  }
  .multiselect-single-dropdown.multiselect--active
  >>> .multiselect__option--selected{
    background: #FFFFFF !important;
    border: 1px solid #0A99FF;

  }
  .multiselect-single-dropdown.multiselect--active
  >>> .multiselect__option--selected span{
    /* font-weight: 600 !important; */
  }
  .multiselect-single-dropdown
    >>> .multiselect__option--selected:before {
    content: none;
  }
  .multiselect--active
  >>> .multiselect__tags::after{
    content: '';
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 11px;
    right: -13px;
    border: 0.5px solid #CCCCCC !important;
    opacity:0.5;
    width: 95%;

  }
  .multiselect-single-dropdown
  >>> .multiselect__single {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    color: #4D4D4D;
    overflow: visible;
    padding-left:0px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__placeholder {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 15px;
    color: #999999;
    overflow: visible;
    /* padding:7px 0px 7px 12px; */
  }
  .multiselect-single-dropdown >>> .multiselect__input::placeholder{
     color: #4D4D4D !important;
     padding-left:4px !important
  }
   /* .multiselect-single-dropdown input::placeholder{
    color: red;
   } */
.multiselect--active
  >>>  .multiselect__single,
  .multiselect--active
  >>> .multiselect__placeholder{
    padding: 4px 40px 4px 12px;
  }
 .multiselect--active
  >>> .multiselect__input{
    padding-left: 1px !important;
    padding-top: 4px !important;
    padding-bottom: 4px;
    margin-bottom: 0px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown >>> .multiselect__input{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    padding-top: 1px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content{
    margin-top: 5px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element span{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element .multiselect__option{
    padding-left: 16px;
    padding-top:11px;
    padding-bottom: 10px;
    padding-right: 0px;
  }
  @media screen and (max-width: 1025px) {
    .multiselect--active
  >>> .multiselect__tags::before{
    left: 10px;
    width:94%
  }
}
.multiselect-single-dropdown.multiselect--active
>>> .multiselect__content-wrapper{
    /* border: 1px solid black; */
    border:1px solid #CCCCCC;
    border-top: none;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    margin-top: 0px;
    max-height: 229px !important;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    /* border-radius:3px !important; */
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper{
    -webkit-box-shadow:none;
     box-shadow: none;
  }
@media (min-width: 1025px) {
  .custom-dropdown{
    padding-bottom:24px;
    margin-bottom:10px;
  }
}
#togglePassword {
    cursor: pointer;
    float: right;
    position: relative;
    top: -30px;
    right: 16px;
}

/* ======================================================== */
.register-wrapper {
  /* padding-bottom: 30px; */
  min-height: 100vh;
  position: relative;
}
.medium_device_logo {
  padding-top: 46px;
  padding-left: 38px;
  padding-bottom: 24px;
}
.horizontal-line {
  border-bottom: 1px solid #D3D6D9;
  margin: 0 28px;
}
.pb-25 {
  padding-bottom: 25px;
}
.break-line {
  border-bottom: 1px solid #B4B4B4;
  margin: 0 16px;
}
.padding-0 {
  padding: 0 !important;
}
.mr-0 {
  margin-right: 0px;
}
.pb-39 {
  padding-bottom: 39px;
}
.pb-15 {
  padding-bottom: 15px;
}
.col-gap-30 {
  column-gap: 30px;
}
.action-buttons a {
  font-weight: 700;
  line-height: 25px;
  color: #01518a;
  font-size: 18px;
}
.mobile-menu-btn {
  position: absolute;
  right: 10px;
  top: 25px;
  z-index: 2;
}
.mobile-menu-btn .menu-btn{
  cursor: pointer;
}
.align-items-end {
  align-items: flex-end;
}
.flex-direction-column {
  flex-direction: column;
}
.row-gap-5 {
  row-gap: 5px;
}
/* Burger menu */
div.x,
div.y,
div.z {
  height: 3px;
  width: 28px;
  background: #333333;
  border-radius: 2px;
  -webkit-transition: all 200ms ease-out;
  -o-transition: all 200ms ease-out;
  transition: all 200ms ease-out;
}

.menu-btn[aria-expanded="true"] > div.x {
  transform: rotate(40deg);
  transform-origin: top left;
  background: #333333;
}
.menu-btn[aria-expanded="true"] > div.y {
  background: #333333;
  display: none;
}
.menu-btn[aria-expanded="true"] > div.z {
  transform: rotate(-45deg);
  background: #333333;
  transform-origin: bottom left;
  margin: 10px 1px 3px 3px;
}

#NavBar_DropDown_Register {
  position: absolute;
  width: 100%;
  z-index: 1;
  top: 0px;
  height: 100%;
  background: #ffffff;
  padding: 0;
  /* background-image: url('/static/images/logos/signup_left_medium_device.svg'); */
}

#NavBar_DropDown_Register li {
  list-style: none;
  background: #f2f2f2;
}

#NavBar_DropDown_Register li:nth-child(even) {
  padding: 9px 0px;
}

#NavBar_DropDown_Register li:last-child {
  padding-bottom: 20px;
}

#NavBar_DropDown_Register li a {
  cursor: pointer;
  color: #01518a;
  padding-left: 28px;
  font-weight: 400;
  font-size: 14px;
}
.img-wrapper {
  background: url('/static/images/logos/signup_bg_desktop.svg') no-repeat;
  background-size: cover;
}
.h-100 {
  min-height: 100vh;
  background-color: #ebebeb;
}
.pl-12{
  padding-left: 12px !important;
}
.pr-12{
  padding-right: 12px !important;
}
.pl-68 {
  padding-left: 68px;
}
.pb-75 {
  padding-bottom: 117px;
}
.plr-48 {
  padding: 0px 48px;
}
.inmetro-acct {
  font-family: 'Open Sans';
  font-weight: 300;
  font-size: 36px;
  line-height: 49px;
  color: #ffffff;
}
.existing-acct {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
  padding: 0px 0px 30px 0px;
}
.existing-acct a {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  color: #00518A;
  padding-left: 8px;
}
.image-content {
  padding-top: 120px;
  padding-left: 70px;
  padding-right: 20px;
}
.inmetro-para {
  padding-top: 43px;
  font-size: 24px;
  line-height: 33px;
  color: #ffffff;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
}
.max-height {
  /* max-height: calc(100vh - 450px); */
  max-height: 60vh;
  /* min-height: 40vh; */
  min-height: 513px;
  overflow-y: scroll;
  background-color: #ffffff;
  border: 1px solid #B3B3B3;
}
.asterisk:after {
  content: '*';
  font-size: 12px;
  color: #B00505;
  position: relative;
  top: -1px;
  margin-left: 3px;
}
.pt-48 {
  padding-top: 48px !important;
}
/* .country-select-dropdown >>> .multiselect__select::before {
  display: inline-block;
  top: 5%;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #686E73;
  transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  border-bottom: none;
  padding: 0px;
} */
/* .country-select-dropdown.invalid-border >>> .multiselect__tags {
  border: 1px solid #a20000 !important;
} */
/* .country-select-dropdown >>> .multiselect__single {
  padding-top: 5px;
  color: #3E3E3E;
  margin-bottom: 6px;
}
.country-select-dropdown >>> .multiselect__option
  color: #3E3E3E;
} */
.form-group{
  margin-bottom: 40px;
}
.form-control::placeholder {
  color:  #999999;
}
.form-group input{
  font-family: 'Open Sans';
  height: unset;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  font-size: 16px;
  color: #4d4d4d !important;
  padding: 6px 0px 6px 11px;
}

/* .country-select-dropdown >>> .multiselect__tags,
.country-select-dropdown.multiselect--active >>> .multiselect__tags
{
  border-radius:4px !important;
  border: 1px solid #686E73;
  height: 40px;
}

.country-select-dropdown >>> .multiselect__select {
  top: 5px;
}

.country-select-dropdown >>> .multiselect__placeholder {
  padding: 5px 0 0 0;
  font-family: 'Open Sans';
} */
.row.content {
  padding: 0px 48px 0px 48px;
}
.login-whitebox {
  display: inline-block;
  padding: 16px 24px 9px 24px;
  background-color: white;
  min-width: 100%;
  min-height: 380px;
  border-radius: 4px;
}
.field_head {
  /* color: #686E73;
  font-family: 'Open Sans';
  font-weight: 600;
  line-height: 19px; */
  font-family: 'Open Sans';
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 22px;
color: #3e3e3e;
padding: 0px 0px 7px 0px;
margin: 0px;
}
.error-close-icon{
  padding-right: 8px;
}
.error-close-icon img{
  margin-bottom: 3px;
}
.ptb-10{
  padding:10px;
}
.content_container {
  text-align: center;
  margin: 0 auto 0px auto;
  width: 100%;
  max-width: 1200px;
  padding: 0px 20px 0px 20px;
}
.crt-acct {
  margin-bottom: 7px;
  padding-top: 27px;
  text-align: left;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
  font-size: 42px;
  line-height: 49px;
  color: #333333;
}
.comp-info {
  padding: 32px 0px 32px 33px;
  font-size: 18px;
  line-height: 25px;
  color: #333333;
  font-family: 'Open Sans';
  text-align: left;
  font-weight: 600;
  margin: 0px;
}
.sign-up {
  font-weight: 500;
  font-size: 32px;
  line-height: 37px;
  color: #0b3c61;
  padding-top: 0px;
  text-align: left;
}
.emergo-contact {
  background: #ffffff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
}
.sign-up-country, .emergo-img{
  text-align: left;
  padding-left: 8px;
}
.sign-up-country {
  padding-top: 8px;
}
.emergo-img {
  width: 152px;
  padding-top: 6px;
}
.country-representation {
  font-size: 24px;
  line-height: 28px;
  color: #0b3c61;
}
.active-account {
  font-weight: 300;
  font-size: 16px;
  line-height: 19px;
  color: #000000;
  padding-right: 65px;
}
.contact-us-back {
  width: 184px;
  height: 36px;
  margin-top: 90px;
  text-align: center;
}
.dismiss-btn {
  color: #0B3C61;
  font-size: 18px;
  line-height: 21px;
  margin-top: 98px;
  padding-left: 24px;
  cursor: pointer;
}
.scnd-col {
  display: flex;
  padding-bottom: 16px;

}
p {
  font-family: 'Open Sans', sans-serif;
}
.required_astric {
  font-size: 12px;
  color: red;
  display: block;
  position: absolute;
  top: 0em;
}

.form-email{
  display: flex;
  grid-gap:10px;
  width: 100%;
  display: inline-block;
}
.info-icon-class{
    display: inline-block;
    position: absolute;
    right: -3px;
    top: 6px;
}
.info-img {
  width: 20px;
  vertical-align: top;
  margin-top: 1px;
  margin-right: -7px;
}
.form-company-name{
  display: flex;
  grid-gap: 10px;
  width: 100%;
  grid-gap: 10px;
  display: inline-block;
}
.terms-conditions {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
  margin-left: 15px;
}
.terms-conditions .scd{
font-family: 'Open Sans';
font-style: normal;
font-weight: 600;
font-size: 18px;
line-height: 22px;
color:#00518A;
cursor: pointer;
}

.scd {
  font-size: 18px;
  color: #01518a;
}

.check-content {
  /* margin-top: 26px; */
  text-align: left;
  display: flex;
  /* align-items: center; */
}

.buttons {
  margin-top: 5px;
  display: flex;
  justify-content: flex-end;
  font-family: 'Open Sans';
}

.create_account_button,.create_account_button[disabled] {
  margin-bottom: 34px;
  background-color: #01518A;
  border: 1px solid #01518A;
  border-radius: 3px;
  padding: 10px 59px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  color: #ffffff;
  margin-top: 24px;
}

.create_account_button:hover {
  color: #ffffff;
}

.cancel_button {
  background: transparent;
  border: 1px solid #2A313A;
  height: 40px;
  min-width: 80px;
  color: #2A313A;
  font-size: 14px;
  border-radius: 4px;
  font-weight: 600;
}

.pb-45 {
  padding-bottom: 45px;
}

hr.line {
  border-top: 0.5px solid #828282;
}
hr {
  margin-top: 20px;
  margin-bottom: 20px;
  border: 0;
  box-sizing: content-box;
  height: 1px !important;
  width: 100%;
}
.complt_cret_acct {
  margin-top: 45px;
  margin-bottom: 65px;
  text-align: left;
}
.comn_border {
  background: #ffffff;
  border: 1px solid #000000;
  box-sizing: border-box;
  border-radius: 3px;
}
.btn {
  padding: 7px 30px;
}
#select-dropdownradius {
  border-radius: 15px;
  border: 0.5px solid #000000;
}

.term-priv a {
  color: #01518a;
  font-size: 20px;
  font-weight: 400;
}
a {
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  text-decoration: none;
  color: rgb(20, 150, 60);
  -webkit-transition: all 0.1s ease;
  -o-transition: all 0.1s ease;
  transition: all 0.1s ease;
  border-bottom: 0px solid rgb(20, 150, 60);
  padding-bottom: 5px;
}
.check-content input {
  width: auto;
}
.container input {
  position: inherit;
  opacity: 1;
  width: 100%;
  height: 40px;
  cursor: auto;
  color: #000000;
  font-size: 16px;
}
@media (min-width: 768px) and (max-width: 992px) {
  .contact-us {
    padding-top: 8px;
  }
  .contact-us-back {
    width: 160px;
  }
  .sign-up {
    margin-bottom: 40px;
  }

  .complt_cret_acct {
    text-align: center;
  }
  .custom-contact {
    padding-left: 27px;
  }
  .container {
    padding-right: 25px;
    padding-left: 25px;
  }
  .active-account {
    padding-right: 50px;
  }
  .scnd-col {
    padding-bottom: 20px;
  }
  .terms-conditions {
    padding-right: 110px;
  }
  .image-content {
    padding-left: 49px;
  }
}

@media screen and (max-width: 767px) {
  .registration-wrapper {
    padding: 0px 24px;
  }
  .emergo-contact {
    width: 100%;
  }
  .emergo-img {
    width: 131px;
    padding-top: 13px;
  }
  .sign-up-country,  .emergo-img{
    padding-left: 16px;
  }
  .sign-up-country {
    padding-top: 6px;
  }
  .scnd-col {
    margin-top: 30px;
    padding-bottom: 20px;
  }
  .sign-up {
    margin-bottom: 40px;
  }

  .complt_cret_acct {
    text-align: center;
  }

  .country-representation {
    font-size: 18px;
    line-height: 21px;
  }

  .active-account {
    font-weight: 300;
    font-size: 14px;
    line-height: 16px;
    padding-right: 40px;
  }
  .pbr-20{
    padding-right:20px;
  }
  .container {
    padding-right: 30px;
    padding-left: 30px;
  }
  div.x,
  div.y,
  div.z {
    height: 3px;
    width: 28px;
    background: #333333;
    border-radius: 2px;
    -webkit-transition: all 200ms ease-out;
    -o-transition: all 200ms ease-out;
    transition: all 200ms ease-out;
  }
}

@media screen and (max-width: 374px) {
  .container {
    padding-right: 25px;
    padding-left: 25px;
  }
}
@media only screen and (max-device-width: 568px) {
  .check-content input {
    width: 40px;
    height: 18px;
  }
  .contact-us-back {
    margin-top: 0px;
  }
  .dismiss-btn {
    margin-top: 5px;
    margin-right: 10px;
    padding-left:20px;
  }
}
.custom-error-class {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #E12D33;
  padding-top: 12px;
  margin: 0px;
}
.custom-warning-class{
  color: #f18a21;
  margin-top: 0px;
  margin-bottom: 5px;
  padding: 8px;
  font-size: 12px;
  line-height: 16px;
}
.custom-success-class{
  color: green;
  margin-top: 0px;
  margin-bottom: 5px;
  padding: 8px;
  font-size: 12px;
  line-height: 16px;
}
.password-must {
  text-align: left;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.7);
  padding-top: 10px;
  padding-left: 13px;
}

ul.password-cond {
  list-style-type: none;
  text-align: left;
  padding-left: 26px;
  padding-bottom: 10px;
}

li.reqrd-field,
.mandatory-field {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: rgba(0, 0, 0, 0.7);
}

li.reqrd-field::before {
  content: "\f111";
  font-family: FontAwesome;
  font-style: normal;
  font-weight: normal;
  text-decoration: inherit;
  color: #4c9e45;
  font-size: 11px;
  padding-right: 6.38px;
}

li.mandatory-field::before {
  content: "\f111";
  font-family: FontAwesome;
  font-style: normal;
  font-weight: normal;
  text-decoration: inherit;
  color: #b00505;
  font-size: 11px;
  padding-right: 6.38px;
}

#divPasswordValidationResult {
  display: block;
  padding: 0px;
  background: #ffffff;
  border: 1px solid #b00505;
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
}

.cancel-icon {
  position: absolute;
  cursor: pointer;
  color: #828282;
  right: 11px;
}
.mg-tp-10 {
  margin-top: 10px;
}
.invalid-border {
  border-color: #E12D33;
  margin-bottom: 0px;
}
/* .multiselect-single-dropdown
  >>> .multiselect__tags */
.invalid-dropdown-border.multiselect-single-dropdown
  >>> .multiselect__tags {
    border: 1px solid #E12D33 !important;
    margin-bottom: 0px;
}
.warning-border {
  border-color: #f18a21;
}
.container .spinnerTop >>> .spinner {
  left: 0;
}
.container .spinnerTop {
  left: 0;
}
h2,
h3 {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}
/* #password,
#cpassword {
  color: #828282;
} */
@media (max-width: 1022px) and (min-width: 992px) {
  .country-representation {
    width: max-content;
  }
  .emergo-img {
    margin-top: 90px;
  }
  .contact-us-back {
    margin-left: -200px;
    margin-top: 100px;
  }
}
@media (min-width: 1025px) and (max-width: 1300px) {
  .mainHeaderNav {
    display: none !important;
  }
}
@media screen and (max-width: 640px) {
  .login-whitebox {
    min-width: 90vw;
  }
}
@media screen and (max-width: 1025px) {
  .pb-39 {
    padding: 0;
  }
}
@media screen and (max-width: 1300px) {
  .img-wrapper {
    background: url('/static/images/logos/Side Image.png')
      no-repeat;
    background-size: cover;
    left: -5px;
  }
  .pt-48 {
    padding-top: 8px !important;
  }
  .pb-75 {
    padding-bottom: 137px;
  }
}

@media only screen and (max-width: 1024px) {
  .mainHeaderNav {
    display: none;
  }
  /* .form-details {
    padding-top: 95px;
  } */
}

@media screen and (max-width: 765px) {
  .img-wrapper {
    background: url('/static/images/logos/signup_bg_mobile.svg')
      no-repeat;
    background-size: cover;
  }
  .register-wrapper {
    flex-direction: column;
    padding: 0 24px !important;
  }
  .max-height {
    overflow-y: unset;
    max-height: unset;
  }
  .image-content {
    padding-top: 46px;
    padding-left: 38px;
  }
  .pb-75 {
    padding-bottom: 52px;
  }
  .h-100 {
    min-height: 60vh;
    max-height: 80vh;
  }
  .inmetro-acct {
    font-size: 24px;
    font-weight: 300;
    line-height: 32px;
  }
  .form-details {
    padding-top: 24px;
    height: 100% !important;
    max-height: unset;
  }
  .pl-68 {
    padding-left: 24px;
  }
  .inmetro-image {
    width: 116px;
  }
  div.x, div.y, div.z {
    background: #ffffff;
  }
  .check-content {
    padding-right: 52px;
    padding-left: 32px;
  }
  /* .create_account_button {
    padding: 10px 75px;
    width: 100%;
  } */
  .checkbox-error{
    width: 100%;
    /* padding-left: 178px;
    padding-right: 176px; */
    /* padding: 10px; */
  }
  .existing-acct {
    display: flex;
    justify-content: center;
  }
  .crt-acct {
    padding-top: 0px;
    display: contents;
  }
  .account-info {
    display: contents;
  }
  .inmetro-para {
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    padding-top: 24px;
  }
}
@media only screen and (min-width: 1301px) {
  .show-md {
    display: none !important;
  }
  #NavBar_DropDown_Register {
    display: none !important;
  }
}
@media screen and (max-width: 1300px) {
  .hide_xs {
    display: none;
  }
  .mobile-menu-btn .menu-btn{
    float: right !important;
}

}
@media screen and (min-width: 1024px) and (max-width: 1300px) {
  /* .form-details {
    padding-top: 95px;
  } */
}
@media screen and (min-width: 768px) and (max-width: 1300px) {
  /* .crt-acct {
    padding-top: 0px;
  } */
}
</style>
